import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";

// Main component
import {AppComponent} from '@app/app.component';

// Routing
import {AppRoutingModule} from '@app/app-routing.module';

// Core
import {CoreModule} from '@core/core.module';

// TECH components
import {TechScrollbarModule} from '@tech/components/tech-scrollbar';

// Default Components
import {LoadingLogoComponent} from '@app/components/loading-logo/loading-logo.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    AppRoutingModule,
    TechScrollbarModule,
    LoadingLogoComponent
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}
